/** 問い合わせ起票経路（BE inquiry_source と同一） */
export const INQUIRY_SOURCE_LABEL: Record<string, string> = {
  corporate_web: "Web",
  support_form: "Support",
  email: "Email",
};

export function inquirySourceBadge(source: string | null | undefined): string | null {
  if (!source) return null;
  return INQUIRY_SOURCE_LABEL[source] || null;
}
